var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebookPaymentsSocial(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 109,
    viewBox: "0 0 58 109",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.25 62.5625H51.6875L57.0625 41.0625H38.25V30.3125C38.25 24.7763 38.25 19.5625 49 19.5625H57.0625V1.5025C55.3102 1.27138 48.6936 0.75 41.7061 0.75C27.113 0.75 16.75 9.65637 16.75 26.0125V41.0625H0.625V62.5625H16.75V108.25H38.25V62.5625Z",
    fill: "#023A5D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookPaymentsSocial);
export default __webpack_public_path__ + "static/media/FacebookPaymentsSocial.51f233bc3938020ed06240e8a9a0379e.svg";
export { ForwardRef as ReactComponent };